import { type AxiosRequestConfig } from 'axios';
import { isAppModule } from '@utils/constants';
import { checkIfFilterManagementEnabled } from '@utils/filter';
import instance from './common';

const baseURLV2 = `${window.__POWERED_BY_QIANKUN__ ? BUILD_VARS.QUERY_DOMAIN : ''}/v2.0`;
// TODO: after filter management GA then the checking for it can be removed
export const getV2AxiosConfig = (config?: AxiosRequestConfig) => {
  const baseConfig = config || {};
  const isNewFilterManagementEnabled = checkIfFilterManagementEnabled();
  if (isNewFilterManagementEnabled) {
    return {
      baseURL: baseURLV2,
      ...baseConfig,
    };
  }
  return baseConfig;
};

export function getMeta<T = any>(config?: AxiosRequestConfig) {
  const reqConfig = getV2AxiosConfig(config);
  return instance.get<T>('/filters/meta', reqConfig).then((resp) => resp.data);
}

export function getAutoCompletion<T = any>(
  url,
  pattern: string | number,
  config?: AxiosRequestConfig,
) {
  let query;
  if (url.includes('?')) {
    query = `${url}&pattern=${pattern}`;
  } else {
    query = `${url}?pattern=${pattern}`;
  }
  return instance.get<T>(query, config);
}

export function getFilters<T = any>(config?: AxiosRequestConfig) {
  const reqConfig = getV2AxiosConfig(config);
  return instance.get<T>('/filters', reqConfig).then((resp) => resp.data);
}

export function createFilter<T = any>(data, config?: AxiosRequestConfig) {
  const reqConfig = getV2AxiosConfig(config);
  return instance.post<T>('/filters', data, reqConfig);
}

export function updateFilter<T = any>(fid, data, config?: AxiosRequestConfig) {
  const reqConfig = getV2AxiosConfig(config);
  if (reqConfig.baseURL) {
    return instance.put<T>(`/filter/${fid}`, data, reqConfig);
  }
  return instance.post<T>(`/filter/${fid}`, data, reqConfig);
}

export function deleteFilter(fid, config?: AxiosRequestConfig) {
  const reqConfig = getV2AxiosConfig(config);
  return instance.delete(`/filter/${fid}`, reqConfig);
}

export function enableFilter<T = any>(fid, config?: AxiosRequestConfig) {
  const reqConfig = getV2AxiosConfig(config);
  return instance.put<T>(`/filter/enable/${fid}`, {}, reqConfig);
}

// TODO: NOTE: backend API does not process rules
// for now, this is only used to load default "All Traffic"
export function searchFilter(query, config?: AxiosRequestConfig) {
  return instance.post('/filters/search', query, config);
}

export function getFiltersByIds<T = any>(filterIds: number[]) {
  const ids = filterIds.join(',');
  if (isAppModule) {
    return instance.get<T>(`/appData/filters?ids=${ids}`).then((resp) => resp.data);
  }
  return instance.get<T>(`/filters?ids=${ids}`, { baseURL: baseURLV2 }).then((resp) => resp.data);
}

// TODO: after app filter api is migrated into new filter service then we can keep the app/video filter api path consistent.
// app experience filter methods
export function getAppMeta<T = any>(config?: AxiosRequestConfig) {
  return instance.get<T>('/filters/meta', config).then((resp) => resp.data);
}

export function createFilterForAppExperience<T = any>(data, config?: AxiosRequestConfig) {
  return instance.post<T>('/appData/filter', data, config);
}

export function updateFilterForAppExperience<T = any>(fid, data, config?: AxiosRequestConfig) {
  return instance.put<T>(`/appData/filter/${fid}`, data, config);
}

export function getFiltersForAppExperience<T = any>(config?: AxiosRequestConfig) {
  return instance.get<T>('/appData/filters', config).then((resp) => resp.data);
}

export function deleteFilterForAppExperience(fid, config?: AxiosRequestConfig) {
  return instance.delete(`/appData/filter/${fid}`, config);
}
